import { HashLink } from "react-router-hash-link"
import { FooterType } from "../../types"
import { API } from "../../constants/constants"
import BaseSubheadline from "./BaseSubheadline"
import { useAccessibility } from "../../context/AccessibilityContext"
import BaseRichtext from "./BaseRichtext"

export default function Footer(props: FooterType) {
    const { getCursorPointerClass } = useAccessibility()

    return (
        <div className="w-full bg-accent py-16 text-neutral px-4">
            <div className="max-w-content mx-auto flex flex-col md:flex-row justify-between items-center text-center md:text-left md:items-end ">
                <img
                    src={API + props.footerContent?.footerLogo?.url}
                    alt={props.footerContent?.footerLogo?.description ?? props.footerContent?.footerLogo?.name}
                    className="w-32 mx-auto object-contain md:hidden"
                />
                {/* LEFT */}
                <div className="md:w-[30%] flex flex-col gap-4">
                    <BaseSubheadline label={"Quicklinks"} />
                    <div className="flex justify-center md:justify-start flex-wrap">
                        {props?.pages?.map((item, index) => (
                            <HashLink
                                key={index}
                                to={item?.url}
                                className={`relative after:content-['|'] after:mx-2 font-bold after:inline-block last:after:content-none break-inside-avoid ${getCursorPointerClass()}`}>
                                {item?.title}
                            </HashLink>
                        ))}
                    </div>
                </div>
                {/* MIDDLE */}
                <div className="w-[30%] hidden md:flex flex-col gap-8">
                    <img
                        src={API + props.footerContent?.footerLogo?.url}
                        alt={props.footerContent?.footerLogo?.description ?? props.footerContent?.footerLogo?.name}
                        className="w-32 mx-auto object-contain "
                    />
                    <BaseRichtext classProps="text-xs text-center" content={props.footerContent?.footerCertificate} />
                </div>
                {/* RIGHT */}
                <div className="md:w-[30%] flex flex-col-reverse md:flex-col gap-4 pt-4 md:pt-0">
                    <div className="flex justify-center md:justify-start gap-2">
                        {props?.footerContent?.footerSocials?.map((item, index) => (
                            <HashLink to={item?.footerSocialsUrl} key={index} className={`p-2 bg-primary rounded-full ${getCursorPointerClass()}`}>
                                <img
                                    src={API + item?.footerSocialsLogo?.url}
                                    alt={item?.footerSocialsLogo?.description ?? item?.footerSocialsLogo.name}
                                    className="w-8 h-8 object-contain"
                                />
                            </HashLink>
                        ))}
                    </div>
                    <BaseRichtext classProps="text-xs" content={props.footerContent?.footerInformation} />
                </div>
                <BaseRichtext classProps="text-xs pt-8 text-center md:hidden" content={props.footerContent?.footerCertificate} />
            </div>
            <div className="max-w-content-sm mx-auto flex flex-wrap justify-center items-center pt-12 gap-4">
                {props.footerContent?.footerPartner?.map((partner, index) => (
                    <div key={index} className={`${getCursorPointerClass()}`} onClick={() => window.open(partner.footerPartnerUrl, "_blank")}>
                        <img
                            src={API + partner.footerPartnerLogo.url}
                            alt={partner.footerPartnerLogo.description || partner.footerPartnerLogo.name}
                            className="w-32 object-contain"
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}
